var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.nav)?_c('div',{staticClass:"mb-40 mb-40-md my-30-sm flex"},[(_vm.type==='parent')?[(_vm.$route.params.parentCategory)?_c('router-link',{staticClass:"pointer underline-hover",attrs:{"tag":"h4","to":{name: 'productsFromNavigation',
      params: {
        navItemName: _vm.$route.params.parentCategory,
        navItemId: _vm.$route.query.navItemId,
      }
    }}},[_vm._v(" "+_vm._s(_vm.$route.params.parentCategory)+" ")]):_vm._e(),_c('h4',[_vm._v(" / ")])]:(_vm.type==='parent + child')?[_c('router-link',{staticClass:"pointer underline-hover",attrs:{"tag":"h4","to":{name: 'productsFromNavigation',
      params: {
        navItemName: _vm.$route.params.parentCategory,
        navItemId: _vm.getParentId(_vm.$route.query.navItemId),
      }
    }}},[_vm._v(" "+_vm._s(_vm.$route.params.parentCategory)+" ")]),_c('h4',[_vm._v(" / ")]),_c('router-link',{staticClass:"pointer underline-hover",attrs:{"tag":"h4","to":{
      name: 'productsFromNavigation',
      params: {
        navItemParentName:_vm.$route.params.parentCategory,
        navItemName: _vm.$route.params.category,
        navItemId: _vm.$route.query.navItemId,
      }
    }}},[_vm._v(" "+_vm._s(_vm.$route.params.category)+" ")]),_c('h4',[_vm._v(" / ")])]:(_vm.type==='parent collection')?[_c('router-link',{staticClass:"pointer underline-hover",attrs:{"to":{
      name: 'ParentCollection',
      params: {
        collectionName: _vm.$route.params.parentCategory,
        collectionId: _vm.$route.query.collectionId,
      }
     },"tag":"h4"}},[_vm._v(" "+_vm._s(_vm.$route.params.parentCategory)+" ")]),_c('h4',[_vm._v(" / ")])]:(_vm.type==='category + collection')?[_c('router-link',{staticClass:"pointer underline-hover",attrs:{"tag":"h4","to":{
        name: 'productsFromNavigation',
        params: {
          navItemName: _vm.$route.params.parentCategory,
          navItemId: _vm.getParentId(_vm.$route.query.collectionId),
        }
    }}},[_vm._v(" "+_vm._s(_vm.$route.params.parentCategory)+" ")]),_c('h4',[_vm._v(" / ")]),_c('router-link',{staticClass:"pointer underline-hover",attrs:{"to":{
      name: 'CollectionWithCategory',
      params: {
        categoryName: _vm.$route.params.parentCategory,
        collectionName: _vm.$route.params.category,
        collectionId: _vm.$route.query.collectionId,
      }
     },"tag":"h4"}},[_vm._v(" "+_vm._s(_vm.$route.params.category)+" ")]),_c('h4',[_vm._v(" / ")])]:[_c('router-link',{staticClass:"pointer underline-hover",attrs:{"tag":"h4","to":{
      name: 'productsFromNavigation',
      params: {
        navItemName: this.category.parent_category_name,
        navItemId: this.getParentId(this.category.id)
      }
    }}},[_vm._v(" "+_vm._s(_vm.category.parent_category_name)+" ")]),_c('h4',[_vm._v(" / ")]),_c('router-link',{staticClass:"pointer underline-hover",attrs:{"tag":"h4","to":{
        name: 'productsFromNavigation',
        params: {
          navItemParentName: this.category.parent_category_name,
          navItemName: this.category.name,
          navItemId: this.category.id
        }
      }}},[_vm._v(" "+_vm._s(_vm.category.name)+" ")]),_c('h4',[_vm._v(" / ")])],_c('h4',[_vm._v(_vm._s(_vm.productName))])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }